// Auto-generated from refreshed-tourney-obj-array.js — do not edit by hand
// Rooms with at least one tournament schedule row (158)
module.exports = [
  "101 Poker Club",
  "4 Bears Casino & Lodge",
  "Ace's Poker Lakewood",
  "Ace's Poker Mountlake Terrace",
  "Agua Caliente Casino, Palm Springs",
  "Alamo City Poker Club",
  "All Star Casino",
  "Amarillo Social Club",
  "Aria Resort & Casino, Las Vegas",
  "Bally's Black Hawk",
  "Bally's Twin River Lincoln",
  "Bay 101",
  "Bear River Casino Hotel",
  "Beau Rivage Casino & Resort",
  "Bellagio Hotel & Casino",
  "bestbet Jacksonville",
  "bestbet St. Augustine",
  "Bestbet, Orange Park",
  "Black Pearl Restaurant & Card Room",
  "Boomtown Casino & Hotel, New Orleans",
  "Borgata Hotel Casino & Spa",
  "Broadway Grill & Pizzeria",
  "Buzz Inn Steakhouse East Wenatchee",
  "Caesars Palace, Las Vegas",
  "Caesars Virginia",
  "Canterbury Park",
  "Capitol Casino",
  "Caribbean Cardroom",
  "Casino 99",
  "Casino Caribbean Kirkland",
  "Casino Caribbean Yakima",
  "Casino Club",
  "Casino del Sol",
  "Central Coast Casino",
  "Champions Club Texas",
  "Champions Social Club",
  "Clearwater Saloon & Casino",
  "Club 52 Poker at Melbourne Greyhound Park",
  "Club One Casino",
  "Club San Rafael",
  "Commerce Casino",
  "Crazy Moose Casino Pasco",
  "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
  "Derby Lane Poker Room",
  "Desert Diamond Casino & Hotel, Tucson",
  "Desert Diamond Casino, West Valley",
  "Doghouse Poker Club",
  "Ebro Poker Room",
  "El Dorado Hills Casino",
  "FireKeepers",
  "Fortune Casino La Center",
  "Fortune Casino Lacey",
  "Fortune Poker Renton",
  "Four Winds Casino South Bend",
  "Foxwoods Casino & Resort",
  "Garlic City Casino & Restaurant",
  "Golden West Casino",
  "Grand Victoria Casino",
  "Graton Resort & Casino",
  "Green Valley Ranch Resort, Casino & Spa",
  "Gun Lake Casino",
  "Hard Rock Casino Rockford",
  "Harrah's Pompano Beach",
  "Harrahs Casino & Resort, Cherokee",
  "Harrahs Casino, New Orleans",
  "Hollywood Casino @ Kansas Speedway",
  "Hollywood Casino, Columbus",
  "Hollywood Park Casino",
  "Hon-Dah Casino",
  "Horseshoe Casino, Council Bluffs",
  "Horseshoe Casino, Southern Indiana",
  "Horseshoe Indianapolis",
  "Horseshoe Las Vegas",
  "Imperial Palace Casino Auburn",
  "Jack Casino, Cleveland",
  "Jackson Rancheria Casino",
  "Jamestown Saloon",
  "Joker's Casino and Sports Bar",
  "Kickapoo Lucky Eagle Casino & Hotel",
  "Lancer Lanes and Casino",
  "Larry Flynt's Lucky Lady Casino",
  "Lilac Lanes & Casino",
  "Little Creek Casino Resort",
  "Livermore Casino",
  "Lone Butte Casino",
  "Lucky Chances",
  "Lucky's Card Room (TGT Poker)",
  "Mandalay Bay, Las Vegas",
  "Maryland Live! Casino",
  "Merced Poker Room",
  "MGM Grand, Detroit",
  "MGM Grand, Las Vegas",
  "Mohegan Sun",
  "Mohegan Sun Pocono",
  "Naples Fort Myers Kennel Club & Poker Room",
  "Nineteenth Hole",
  "Ocala Bets",
  "Ocean's 11 Casino",
  "Oceanview Card Room",
  "One-Eyed Jack's Poker Room",
  "Orange City Racing and Card Club",
  "Outlaws Card Parlour",
  "Oxford Downs",
  "Palace Poker Texas",
  "Palm Beach Kennel Club, West Palm Beach",
  "Parkwest Casino Lodi",
  "Parx Casino",
  "Players Casino",
  "Poker House Fort Worth",
  "Prairie Meadows",
  "Razzals Bar & Grill",
  "Red Rock Casino Resort & Spa",
  "Rivers Casino",
  "Rivers Casino Portsmouth",
  "Rivers Casino, Des Plaines",
  "Roxbury Lanes Casino",
  "Running Aces Casino & Racetrack",
  "Saracen Casino Resort",
  "Seminole Casino, Coconut Creek",
  "Seminole Hard Rock Hotel & Casino, Hollywood",
  "Seminole Hard Rock Hotel & Casino, Tampa",
  "Shuffle 214",
  "Shuffle 512",
  "Slo Pitch Pub & Eatery",
  "Soaring Eagle Casino & Resort",
  "South Point Hotel, Casino & Spa",
  "Spades Poker House Baytown",
  "Spades Poker House Webster",
  "Stars Casino",
  "Stones Gambling Hall",
  "Sycuan Casino",
  "Talking Stick",
  "Tampa Bay Downs",
  "TCH Social Austin",
  "TCH Social Las Colinas",
  "Texas Card House Dallas",
  "Texas Card House Houston",
  "Texas Card House Rio Grande Valley",
  "Texas Card House Spring",
  "The Aviator Casino",
  "The Bicycle Hotel & Casino",
  "The Big Easy Casino",
  "The Casino @ Dania Beach",
  "The Fort Card Room",
  "The Gardens Casino",
  "The Hangar Poker House",
  "The Lodge Card Club Round Rock",
  "The Lodge Card Club San Antonio",
  "The Orleans Hotel & Casino",
  "The Sands Casino, Bethlehem",
  "The Venetian",
  "Thunder Valley Casino",
  "Towers Casino & Card Room",
  "Turlock Poker Room",
  "Turning Stone Resort & Casino",
  "Westgate Las Vegas Resort & Casino",
  "Wheeling Island Hotel, Casino & Racetrack",
  "Wynn, Las Vegas"
];



// WEBPACK FOOTER //
// ./js/rooms-with-schedules.js